import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentClient } from '$lib/services/experiments/client_v2';
import { ProductExperienceService } from '$lib/services/product-experience';
import { app } from '$lib/stores/app/store';
import { AOFL_PRODUCT_NAMES, LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';
import { get } from 'svelte/store';

const isLinkFrom1_0App = () => {
	const { linkFromAppPlatform } = get(app).global;
	return (
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS_1_0 ||
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.ANDROID_1_0
	);
};

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	inApp: {
		condition: async (config) => {
			return config.meta.inApp;
		},
		resolve: async () => {
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_in-app/Page.svelte');
		},
	},
	oauthLoginExperiment: {
		condition: async () => {
			if (isLinkFrom1_0App()) return false;
			await experimentClient.initializeExperiment(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey
			);
			return experimentClient.isVariantActive(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey,
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.variants.test
			);
		},
		resolve: async () => await import('../_login-oauth-choice/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_login-magic-link/Page.svelte'),
	},
};

export { pageConditions };
